<template>

	<div id="youtube" :class="this.size ? this.size : '' ">
		<iframe :src="this.itemYoutube.data" title="YouTube video player" frameborder="0" allow=""
			referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
	</div>

</template>
<script>

//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
//import { logMixin } from "@/mixins/logMixin.js";

export default {
	name: "ItemList",
	components: {},
	mixins: [],
	props: {
		productId: Number,
		itemYoutube: Object,
		parentTitle: String,
		size:{
			type: String,
			default: ""
		}
	},
	data() {
		return {
		};
	},
	computed: {

		title() {
			return this.parentTitle + "\nItemRow: " + this.item?.itemId
		},

		itemList() {
			return this.product?.details?.itemList
		},

		
		product() {

			if (this.productId > 0) {
				return this.$store.state.productStore.data.productList[this.productId]
			}

			return null;

		},

	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });


	},
	created() {

	}
};
</script>

<style scoped>


div#youtube {
	position: relative;
	display: block;
	width: 100%;
	/* width of iframe wrapper */
	height: 0;
	margin: auto;
	padding: 0% 0% calc(56.25% / 1) 0%;
	/* 16:9 ratio */
	overflow: hidden;
	background: white;
}

div#youtube.size50 {
	width: calc(50% - 5px);
	padding: 0% 0% calc(56.25% / 2) 0%;
}

div#youtube.size33 {
	width: calc(33% - 3px);
	padding: 0% 0% calc(56.25% / 3) 0%;
}

div#youtube.size25 {
	width: calc(25% - 5px);
	padding: 0% 0% calc(56.25% / 4) 0%;
}

div#youtube iframe {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 100%;
	border: 0;
}

@media (max-width: 768px) {
	div#youtube,
	div#youtube.size50,
	div#youtube.size33,
	div#youtube.size25 {
		width: 100%;
		padding: 0% 0% calc(56.25% / 1) 0%;
	}
}

</style>